export default __webpack_public_path__ + "static/media/spillemyndigheden.50427225.png";